import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useStore } from "vuex";
import { customInstance, type ErrorType } from "@/custom-axios";
import { IS_AUTH_BUILD_TARGET } from "@/config";
import { tenantSettingsQueryKey } from "./queryKeys";
import type { TenantSettingsResponse } from "./types";

const getTenantSettings = async (): Promise<TenantSettingsResponse> => {
  const response = await customInstance<{ data: TenantSettingsResponse }>(
    "/api/frontend/common/settings",
    { method: "GET" },
  );
  return response.data;
};

export function useTenantSettings() {
  const store = useStore();
  const isAuthenticated = computed(() => store.getters["auth/isAuthenticated"] as boolean);

  return useQuery<TenantSettingsResponse, ErrorType<unknown>>({
    queryKey: tenantSettingsQueryKey(),
    queryFn: getTenantSettings,
    enabled: computed(() => isAuthenticated.value && !IS_AUTH_BUILD_TARGET),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
